__turbopack_context__.v({
  "container": "index-module__7ukL7G__container",
  "measure": "index-module__7ukL7G__measure",
  "word": "index-module__7ukL7G__word",
  "wordBeforeEnter": "index-module__7ukL7G__wordBeforeEnter",
  "wordExiting": "index-module__7ukL7G__wordExiting",
  "wordIdle": "index-module__7ukL7G__wordIdle",
});
